export default "__VITE_ASSET__63e83d93__"